import React, { useState } from 'react';
import { useSelector } from 'react-redux';
import moment from 'moment';
import { FlexboxGrid, Button, ButtonToolbar } from 'rsuite';
import { get, map, reduce, values } from 'lodash/fp';
import { getAll as getLowStockItemsResult } from '../../../../../redux/Inventory/selectors/reports/low-stock-items';
import { locationOptionValuesToLabels } from '../../../../../redux/Inventory/selectors/components/adjust-item-form';
import { getLowStockItemsSearchQuery } from '../../../../../redux/Inventory/selectors/components/reports/low-stock-items';
import ReportTemplateFormModal from '../../../../../containers/ReportTemplateFormModal';
import ClientExportButton from '../../../../../components/ClientExportCsvButton';
import { LOW_STOCK_ITEMS } from '../../../../../helpers/ReportTemplateTypes';
import SearchDetails from '../../../../../components/inventory/reports/SearchDetails';
import tableColumns from '../../../../../components/inventory/reports/LowStockItemsList/columns';

export default function ResultHeader() {
  const [
    showReportTemplateFormModal,
    setShowReportTemplateFormModal
  ] = useState(false);
  const searchQuery = useSelector(getLowStockItemsSearchQuery);
  const searchResult = useSelector(getLowStockItemsResult);

  const { inventoryLocationId } = searchQuery;

  const searchDetails = [
    {
      label: 'Inventory Locations',
      value: useSelector(state =>
        locationOptionValuesToLabels(state, inventoryLocationId)
      )
    }
  ];

  const exportHeaderData = [
    {
      label: 'As of Date',
      value: moment().format('LLL')
    },
    ...searchDetails
  ];

  const exportColumns = map('label', values(tableColumns));
  const exportData = map(
    row =>
      reduce(
        (rowData, { dataKey }) => [...rowData, get(dataKey, row)],
        [],
        tableColumns
      ),
    searchResult
  );

  const handleOpenReportTemplateFormModal = () => {
    setShowReportTemplateFormModal(true);
  };

  const handleCloseReportTemplateFormModal = () => {
    setShowReportTemplateFormModal(false);
  };

  return (
    <FlexboxGrid justify="space-between">
      <FlexboxGrid.Item colspan={19}>
        <SearchDetails data={searchDetails} itemWidth="100%" />
      </FlexboxGrid.Item>
      <FlexboxGrid.Item colspan={5}>
        <ButtonToolbar style={{ textAlign: 'right' }}>
          <Button
            appearance="ghost"
            onClick={handleOpenReportTemplateFormModal}
          >
            Save Preset
          </Button>
          <ClientExportButton
            filename={`low_stock_items_${moment().format('YMMDD')}`}
            headerData={exportHeaderData}
            columns={exportColumns}
            data={exportData}
          />
        </ButtonToolbar>
        <ReportTemplateFormModal
          fileType={LOW_STOCK_ITEMS}
          file={searchQuery}
          show={showReportTemplateFormModal}
          onSubmitted={handleCloseReportTemplateFormModal}
          handleClose={handleCloseReportTemplateFormModal}
        />
      </FlexboxGrid.Item>
    </FlexboxGrid>
  );
}
